
define('text!templates/modules/dashboard/graph/graph.html',[],function () { return '<div class="graph-content"></div>\n';});

